export default __webpack_public_path__ + "media/images/16-3d7e7443c474b0df245ec5406f042c21.jpg";